import React from "react";
import { Table } from "semantic-ui-react";

const EmployeeExpandedComponent = ({ data }) => {
    // console.log(data);
    return (
        <>
            <Table basic='very' compact celled collapsing style={{padding: 20, marginLeft: 50}}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Father Name</Table.HeaderCell>
                        <Table.HeaderCell>Address</Table.HeaderCell>
                        <Table.HeaderCell>Area</Table.HeaderCell>
                        <Table.HeaderCell>Date of Birth</Table.HeaderCell>
                        <Table.HeaderCell>Date of Joining</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{data.father_name}</Table.Cell>
                        <Table.Cell>{data.address}</Table.Cell>
                        <Table.Cell>{data.area}</Table.Cell>
                        <Table.Cell>{data.dob}</Table.Cell>
                        <Table.Cell>{data.doj}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </>
    )
}

export default EmployeeExpandedComponent